module.exports = __webpack_public_path__ + "static/media/contact-hero-background.73bae4ee.jpg";